import React from 'react';

import { Skeleton, Stack } from '@chakra-ui/react';

import { ApiEndpointPage } from './ApiEndpointPage';
import { ApiNotice } from './ApiNotice';
import { ApiServicePage } from './ApiServicePage';
import { ApiRoute } from './types';
import { ApiServiceState } from './useApiReference';
import { API_SERVICES } from './utils';

/** The article for an API reference URL: a service or one endpoint. */
export const ApiReferenceView = ({
  route,
  services,
  onOpen,
}: {
  route: ApiRoute;
  services: Record<string, ApiServiceState>;
  onOpen: (url: string) => void;
}) => {
  const service = API_SERVICES.find(item => item.id === route.service);
  const state = services[route.service];
  if (!service) return <ApiNotice>This API isn't documented.</ApiNotice>;
  if (!state || state.status === 'loading')
    return (
      <Stack spacing={4}>
        <Skeleton height="42px" />
        <Skeleton height="280px" />
      </Stack>
    );
  if (state.status === 'error')
    return (
      <ApiNotice>
        The {service.title} API reference couldn't be loaded. Refresh the page
        or try again later.
      </ApiNotice>
    );
  if (!route.operation)
    return (
      <ApiServicePage
        title={service.title}
        operations={state.operations}
        onOpen={onOpen}
      />
    );
  const operation = state.operations.find(item => item.id === route.operation);
  return operation ? (
    <ApiEndpointPage operation={operation} serviceTitle={service.title} />
  ) : (
    <ApiNotice>
      This endpoint is no longer part of the public API. Choose another one from
      the list.
    </ApiNotice>
  );
};
